import { defineMessages } from 'react-intl';

const messages = defineMessages({
  customBrandingTitle: {
    description: 'branding tab custom branding settings title',
    defaultMessage: 'Branded Pages Custom Settings',
    id: 'vDhvLK',
  },
  customBrandingDescription: {
    description: 'branding tab custom branding settings description',
    defaultMessage:
      'Use these settings to brand your <strong>tracking</strong> and <strong>returns</strong> pages.  These pages allow you to re-engage your customers after their packages have shipped.',
    id: '474AoI',
  },
  overrideBrandingSettings: {
    description: 'branding tab custom branding settings override default branding title',
    defaultMessage: 'Override default <strong>Branded Customer Pages</strong> settings',
    id: 'lr4QpX',
  },
  showStoreLogo: {
    description: 'branding tab show store logo checkbox title',
    defaultMessage: 'Show Store Logo',
    id: 'yZkSIf',
  },
  showStoreLogoDesc: {
    description: 'branding tab show store logo checkbox description',
    defaultMessage: 'Configured for each store',
    id: '5T54Y/',
  },
  customColors: {
    description: 'branding tab show custom colors checkbox title',
    defaultMessage: 'Custom Colors',
    id: 'Rr7tvM',
  },
  customColorsDesc: {
    description: 'branding tab show custom colors checkbox description',
    defaultMessage: 'Use custom colors that match your brand',
    id: 'aGs+6i',
  },
  previewNote: {
    description: 'new email experience preview note',
    defaultMessage: 'You can preview all of your Branded Email Notifications here.',
    id: 'StSVEE',
  },
  showCustomTemplateLayout: {
    description: 'branding defaults show custom template layout checkbox title',
    defaultMessage: 'Customize Design',
    id: 'KpH1+g',
  },
  showSocialLinks: {
    description: 'branding tab show social media links checkbox title',
    defaultMessage: 'Show Social Media Links',
    id: 'A2+Etv',
  },
  showSocialLinksDesc: {
    description: 'branding tab show social media links checkbox description',
    defaultMessage: 'For each social media profile that is configured for each store',
    id: '42A5RA',
  },
  showServiceMenu: {
    description: 'branding tab show service menu checkbox title',
    defaultMessage: 'Show Service Menu',
    id: 'i2QMTd',
  },
  showOrderDetails: {
    description: 'branding tab show order details checkbox title',
    defaultMessage: 'Show Order Details',
    id: 'ALAW7m',
  },
  showOrderDetailsDesc: {
    description: 'branding tab show order details checkbox desc',
    defaultMessage: 'Show items that were ordered - optionally include options, prices, SKUs, and images',
    id: 'clx70O',
  },
  showPromoImage: {
    description: 'branding defaults show promo image checkbox title',
    defaultMessage: 'Show Promotional Image',
    id: 'yT4nGQ',
  },
  showPromoImageDesc: {
    description: 'branding defaults show promo image checkbox desc',
    defaultMessage: 'Add a popular product to increase upsell across your buyers',
    id: 'xxvX2U',
  },
});

export default messages;
